import { AnyAction } from 'redux';
import * as constants from 'redux/constants/reservations.constants';
import { ITableUpdate } from 'types/table.types';
import { IReservationsFormData } from 'views/public/ReservationsView/components/ReservationsForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.RESERVATIONS_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.RESERVATIONS_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.RESERVATIONS_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.RESERVATIONS_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IReservationsFormData, id?: string): AnyAction => ({
  type: constants.RESERVATIONS_ON_SAVE_REQUESTED,
  formData,
  id,
});
